(function () {
  'use strict';

  angular.module('app').component('packagePage', packageDetailCtrl());

  function packageDetailCtrl() {
    return {
      bindings: {},
      controller: PackageDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/packages/package-page.component.html',
    };
  }

  PackageDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'PackageService',
    'LanguageService',
  ];

  function PackageDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    PackageService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_package_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    // Methods
    vm.onSavedItem = onSavedItem;

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Initializers
    // getPackage();
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getPackage();
      });
    }

    function getPackage() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        PackageService.getPackage(itemId, { lang: vm.defaultLanguage, show_contents: true }).then(
          function (data) {
            vm.item = data;

            vm.loadingItem = false;
          }
        );
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/packages/${item.id}`);
    }
  }
})();
